var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pm-simple-component-layout',{attrs:{"toolbar-back":_vm.toolbarBack}},[_c('template',{slot:"title"},[_vm._v("\n        Terms & Conditions\n    ")]),(!_vm.isIOS)?_c('pm-tos-android'):_vm._e(),(_vm.isIOS)?_c('pm-tos-ios'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }